import { observable, computed, action, makeObservable, runInAction } from "mobx";
import { SuburbModel } from "../models/SuburbModel";
import { PopupModalModel } from "../models/PopupModalModel";
import { VariantModel } from "../models/VariantModel";
import BreakpointStore from "../stores/BreakpointStore";
import { ModelWalkDetailedPricing } from "../components/ModelWalk/ModelWalkDetailedPricing";
import { ApiBasePath } from "../utils/ApiBasePath";
import * as Request from "superagent";
import ReactDOMServer from "react-dom/server";
import CustomEvent from "custom-event";
import Cookie from "js-cookie";

export class WeeklyRepayment {
  @observable comparisonRate: number = 0;
  @observable paymentValue: number = 0;
  constructor(comparisonRate: number, paymentValue: number) {
    makeObservable(this);
    this.comparisonRate = comparisonRate;
    this.paymentValue = paymentValue;
  }
}

export default class ModelWalkStore {
  @observable breakpoint: BreakpointStore = new BreakpointStore();
  @observable variants: VariantModel[] = null;
  @observable showPricingDetails: boolean = false;
  @observable showSedan: boolean = true;
  @observable showVariantGrouping = false;
  @observable modelName = "";
  @observable
  suburb: SuburbModel = {
    postcode: "2000",
    name: "Sydney",
    fullName: "Sydney, NSW 2000",
    state: "New South Wales",
  };
  stateSelection: SuburbModel = {
    postcode: "2000",
    name: "Sydney",
    fullName: "Sydney, NSW 2000",
    state: "NSW",
  };
  constructor(
    variants: VariantModel[],
    enableStaticPricingByState: boolean = false,
    showVariantGrouping: boolean = false,
    modelName: string = ""
  ) {
    makeObservable(this);
    this.variants = variants;
    this.showVariantGrouping = showVariantGrouping;
    this.modelName = modelName;
    var savedCookie = localStorage.getItem("suburb");
    if (savedCookie) {
      this.stateSelection = JSON.parse(savedCookie);
    }
    this.updateVariantsPricing(enableStaticPricingByState);

    window.addEventListener("locationSelected", (e: any) => {
      this.updateSuburb(e.detail.suburb);
      this.stateSelection = e.detail.suburb;
      this.updateVariantsPricing(enableStaticPricingByState);
    });
    window.addEventListener("stateSelected", (e: any) => {
      this.stateSelection = e.detail.suburb;
      this.updateVariantsPricing(enableStaticPricingByState);
    });
  }

  @action updateSuburb(suburb) {
    this.suburb = suburb;
  }

  @action toggleDisplayedVariant = (value: boolean): void => {
    this.showSedan = value;
  };

  showPostcodeOverlayActive(): void {
    // const evt = new CustomEvent("showPostcodeOverlay", { detail: {} });
    const evt = new CustomEvent("selectLocation", { detail: {} });
    window.dispatchEvent(evt);
  }

  @action updateVariantsPricing(enableStaticPricingByState: boolean) {
    if (this.variants) {
      this.variants.map((variant: VariantModel) => {
        variant.rdp = 0;
        if (enableStaticPricingByState) {
          if (!this.stateSelection.state) return;
          var matchFound = variant.variantPricesByState.find(
            (x) => x.state == this.stateSelection.state
          );
          variant.rdp = matchFound ? matchFound.rdp : 0;
          variant.mlp = matchFound ? matchFound.mlp : 0;
          const evt = new CustomEvent("priceUpdated", { detail: { variant } });
          window.dispatchEvent(evt);
        } else {
          this.getDriveawayPriceByVariant(
            variant,
            (response) => {
              if (response.body !== null) {
                runInAction(() => {
                  variant.rdp = response.body.rdp;
                  variant.mlp = response.body.mlp;
                  // Force MobX to detect array change by triggering a shallow copy
                  this.variants = [...this.variants];
                });
                const evt = new CustomEvent("priceUpdated", {
                  detail: { variant },
                });
                window.dispatchEvent(evt);
              }
            },
            () => {
              console.error("An error occurred loading the prices");
            }
          );
        }
      });
    }
  }

  getDriveawayPriceByVariant(
    variant: VariantModel,
    successCallback: (response: Request.Response) => any,
    failureCallback: (error: any) => any
  ) {
    if (!this.suburb.postcode) return;
    let postcode = this.suburb.postcode.toString();

    if (postcode.length === 3) {
      postcode = "0".concat(postcode);
    }
    const url = `/api/pricing/${postcode}/${variant.id}`;
    Request.get(url).then(successCallback, failureCallback);
  }

  showDetailedPricing(variant: VariantModel): void {
    const modalContent = ReactDOMServer.renderToStaticMarkup(
      ModelWalkDetailedPricing(variant)
    );
    const content: PopupModalModel = {
      title: variant.name,
      text: modalContent,
    };
    const evt = new CustomEvent("showPopupModal", { detail: { content } });
    window.dispatchEvent(evt);
  }

  showCtaUrl(ctaUrl: string): void {
    window.open(ctaUrl, "_blank");
  }
}
